import { ArrowRight } from 'lucide-react';
import Reveal from '../components/Reveal';

const OFICIOS = [
  {
    num: '01',
    title: 'Consultoría',
    desc: 'Apoyada en inteligencia artificial para descifrar los desafíos post-explosión IA. Aplicaciones en entornos corporativos, sin mayores costos.',
  },
  {
    num: '02',
    title: 'Automatizaciones',
    desc: 'n8n, scripts, integraciones REST. Tareas que dejan de doler. Reportes que se generan solos.',
  },
  {
    num: '03',
    title: 'Desarrollo web',
    desc: 'React, FastAPI, microservicios, Postgres. Producto en producción, no en deck.',
  },
];

const STACK = [
  'python','node','postgres','openai','anthropic','n8n','react','fastapi','docker',
];

export default function Oficios() {
  return (
    <section
      id="oficios"
      aria-label="Oficios"
      className="bg-papel text-carbon py-28 md:py-32 px-6 md:px-10"
    >
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="font-mono text-[11px] tracking-[0.2em] uppercase text-tierra">
            02 · OFICIOS
          </div>
        </Reveal>
        <Reveal delay={0.05}>
          <h2
            className="font-display font-display-axes font-normal leading-none tracking-[-0.02em] mt-4 mb-14 md:mb-16"
            style={{ fontSize: 'clamp(44px, 7vw, 88px)' }}
          >
            Tres oficios,{' '}
            <span className="font-display italic font-display-italic-axes text-tierra">
              un mismo paso.
            </span>
          </h2>
        </Reveal>

        <div role="list" className="border-t border-carbon/15">
          {OFICIOS.map((s, i) => (
            <Reveal key={s.num} delay={0.1 + i * 0.08}>
              <a
                href="#contacto"
                role="listitem"
                className="group grid grid-cols-[80px_1fr_40px] md:grid-cols-[100px_1.2fr_1.4fr_40px]
                           items-baseline gap-6 md:gap-10
                           py-7 md:py-8 border-b border-carbon/15
                           text-carbon no-underline
                           transition-colors hover:bg-carbon/[0.025]"
              >
                <span className="font-mono text-xs tracking-[0.2em] text-niebla">{s.num}</span>
                <h3
                  className="font-display font-display-axes font-normal leading-[1.05] tracking-[-0.01em]"
                  style={{ fontSize: 'clamp(28px, 4vw, 44px)' }}
                >
                  {s.title}
                </h3>
                <p className="text-[15px] leading-[1.6] text-carbon/70 col-span-2 md:col-span-1 mt-2 md:mt-0">
                  {s.desc}
                </p>
                <span className="text-tierra justify-self-end col-start-3 md:col-start-4 row-start-1 md:row-auto transition-transform group-hover:translate-x-1.5">
                  <ArrowRight size={22} strokeWidth={1.4} />
                </span>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-12 flex flex-wrap gap-2">
            {STACK.map((t) => (
              <span
                key={t}
                className="font-mono text-[11px] tracking-[0.16em] uppercase
                           px-3.5 py-2 rounded-full
                           bg-carbon/[0.04] border border-sendero/30 text-carbon"
              >
                {t}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
